import { axiosInstance } from './api';

/** Сети (бренды) филиалов и branch-level плагины сетей (BE: services/api/brand_plugin.py,
 *  реестр cctv_core/brand_plugins.py). Плагин активен только у филиалов своей сети. */
export interface BrandDto {
  id: number;
  code: string;
  name: string;
  website: string;
  plugin: { name: string; capabilities: string[] } | null;
}

export const listBrands = () => axiosInstance.get<BrandDto[]>('/core/api/brands/');

export const createBrand = (payload: Pick<BrandDto, 'code' | 'name' | 'website'>) =>
  axiosInstance.post<BrandDto>('/core/api/brands/', payload);

export interface SiteHoursRow {
  weekdays_mask: number;
  open_time: string; // HH:MM
  close_time: string;
}

/** Сверка часов работы с внешним источником (BE: services/api/working_hours_checks.py,
 *  реестр cctv_core/working_hours_sources.py; ночью — check_working_hours_sources). */
export type HoursCheckStatus = 'match' | 'mismatch' | 'ours_missing' | 'unreadable';

export interface HoursCheckDto {
  source: string;          // brand_site | yandex | 2gis
  name: string;            // «сайт», «Яндекс Картами», «2ГИС» — для «Совпадает с …»
  status: HoursCheckStatus | null; // null — ещё не проверяли
  checked_at: string | null;
  source_url: string;
  rows: SiteHoursRow[];
  diff: { day: string; source: [string, string] | null; ours: [string, string] | null }[];
  error: string | null;
}

export interface HoursChecksDto {
  checks: HoursCheckDto[];
  ours: SiteHoursRow[];
  /** Источники, которых у филиала нет, но можно подключить — пунктирные «Привязать …» (#1324). */
  linkable?: { source: string; name: string; to: string }[];
  /** Синк часов с сайтом и картами отключён (Алексей 27.10): ночь расписание не трогает. */
  sync_disabled?: boolean;
  sync_note?: string;
  sync_changed_by?: string;
  sync_changed_at?: string | null;
  /** Может ли пользователь включать/выключать синк (configure_zone). */
  can_edit?: boolean;
}

export const getHoursChecks = (zoneId: string) =>
  axiosInstance.get<HoursChecksDto>(`/core/api/zones/${zoneId}/working-hours-checks/`);

export const refreshHoursCheck = (zoneId: string, source: string) =>
  axiosInstance.post<HoursChecksDto>(`/core/api/zones/${zoneId}/working-hours-checks/${source}/`, {});

/** Записать расписание источника как недельное расписание филиала. */
export const applyHoursFromSource = (zoneId: string, source: string) =>
  axiosInstance.post<HoursChecksDto>(`/core/api/zones/${zoneId}/working-hours-checks/${source}/apply/`, {});

/** Включить/выключить синк часов с сайтом и картами; note — почему отключён. */
export const setHoursSync = (zoneId: string, body: { disabled?: boolean; note?: string }) =>
  axiosInstance.post<HoursChecksDto>(`/core/api/zones/${zoneId}/working-hours-sync/`, body);
